import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class LineChannelContent extends Component {
    static propTypes = {
        qrCodeUrl: PropTypes.string.isRequired,
    };

    render() {
        const { qrCodeUrl } = this.props;
        return <img alt="LINE QR code" style={{ width: '40%' }} src={qrCodeUrl} />;
    }
}
